// config.ts

import { spinTogetherEnabledForTelegramUser } from "../logic/helpers/spinTogetherAccess";

export const NAME_SPACE: string = "__pbtg__";
// ___short git commit hash injected at build time (see vite.config.ts);
// lets us tell stale-cache client errors apart from bugs in the latest build
export const BUILD_ID: string = __BUILD_ID__;
export const CLIENT_VERSION: string = __COMMIT_HASH__;
export const BUILD_TIME: string = __BUILD_TIME__;

const NODE_ENV = import.meta.env.VITE_NODE_ENV;
const API_BASE_OVERRIDE = import.meta.env.VITE_API_BASE_OVERRIDE;
export const DEVELOPMENT_TOOLS_ENABLED =
    import.meta.env.DEV || NODE_ENV === "development";
export const POSTHOG_ENABLED =
    import.meta.env.VITE_POSTHOG_ENABLED === "true";
export const API_BASE: string =
    typeof API_BASE_OVERRIDE === "string" && API_BASE_OVERRIDE.trim()
        ? API_BASE_OVERRIDE.trim()
        : NODE_ENV === "development"
          ? "https://dev-api.pb.bridge.cm"
          : "https://api.pb.bridge.cm";
export const TON_CONNECT_MANIFEST_URL = `${window.location.origin}/tcm/${NODE_ENV}/tonconnect-manifest.json`;
export const TELEGRAM_MINI_APP_URL =
    NODE_ENV === "development"
        ? "https://t.me/pebbler_dev_bot/dev"
        : "https://t.me/pebbler_bot/app";
export const TON_CONNECT_TWA_RETURN_URL = TELEGRAM_MINI_APP_URL;

export function isSpinTogetherEnabledForTelegramUser(
    telegramUserId: string | number | bigint | null | undefined,
): boolean {
    return spinTogetherEnabledForTelegramUser({
        telegramUserId,
        environment: NODE_ENV,
        configuredTelegramUserIds: import.meta.env
            .VITE_SPIN_TOGETHER_TELEGRAM_USER_IDS,
    });
}
